export const enum FormPropertyReportStatechartEvent {
  /**
   * User wants to send report
   */
  wantToSendReport = 'wantToSendReport',

  /**
   * Form validation passed
   */
  validationPassed = 'validationPassed',

  /**
   * Form validation failed
   */
  validationFailed = 'validationFailed',

  /**
   * Google captcha value changed
   */
  captchaValueChanged = 'captchaValueChanged',

  /**
   * Report was created on server
   */
  reportCreated = 'reportCreated',

  /**
   * Failed to create report on server
   */
  reportCreateFailed = 'reportCreateFailed',

  /**
   * Report form has attachment
   */
  hasAttachment = 'hasAttachment',

  /**
   * Report form has no attachment
   */
  hasNoAttachment = 'hasNoAttachment',

  /**
   * Attachment was uploaded successfully
   */
  uploadSuccessful = 'uploadSuccessful',

  /**
   * Failed to upload attachment
   */
  uploadFailed = 'uploadFailed',

  /**
   * Report was already sent
   */
  wasAlreadySent = 'wasAlreadySent',

  /**
   * Report was not sent
   */
  wasNotSent = 'wasNotSent',

  userUpdateSuccess = 'userUpdateSuccess',

  userUpdateFailed = 'userUpdateFailed',
}
